"use client"
import { FC, Suspense } from "react";

import { HeaderProvider } from "context";

import { IDatoGeneralMeta } from "@types";
import { Header } from "./Header";

interface Props {
  logo: IDatoGeneralMeta["logo"];
  secondaryNavbarItems: IDatoGeneralMeta["secondaryNavigation"];
  mainNavbarItems: IDatoGeneralMeta["mainNavigation"];
  navCta: IDatoGeneralMeta["navCta"];
}

export const HeaderContainer: FC<Props> = ({
  logo,
  secondaryNavbarItems,
  mainNavbarItems,
  navCta,
}) => {
  return (
    <HeaderProvider>
      <Suspense>
        <Header
          logo={logo}
          secondaryNavbarItems={secondaryNavbarItems}
          mainNavbarItems={mainNavbarItems}
          navCta={navCta}
        />
      </Suspense>
    </HeaderProvider>
  );
};
